module.exports = __webpack_public_path__ + "media/images/icon/blue/ico_angle_down-23cc13b34c0ef1eae1a0ea743a9926b3.svg";